import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";

export enum MP_RESULT {
  CANCEL,
  ERROR,
  OK,
}

export type MpConfig = {
  msg: string;
  title?: string;
  image?: string;
  btnOk?: string;
  btnError?: string;
  btnCancel?: string;
};

@Component({
  selector: 'app-msg-popup',
  styleUrls: ['./msg-popup.component.scss'],
  template: `
    <article *ngIf="config"
             class="popup">

      <div class="popup-wrapper">

        <article class="popup-msg-form">
          <div *ngIf="config.title"
               class="head-box"
               [innerHTML]="config.title | resize">
          </div>

          <div class="body-box"
               [innerHTML]="config.msg | resize">
          </div>

        </article>

        <div class="popup-foot-box">
          <a *ngIf="config.btnOk"
             class="popup-foot-btn type-1"
             (click)="onClickBtn($event, MP_RESULT.OK)">{{ config.btnOk }}</a>

          <a *ngIf="config.btnError"
             class="popup-foot-btn type-2"
             (click)="onClickBtn($event, MP_RESULT.ERROR)">{{ config.btnError }}</a>

          <a *ngIf="config.btnCancel"
             class="popup-foot-btn type-3"
             (click)="onClickBtn($event, MP_RESULT.CANCEL)">{{ config.btnCancel }}</a>
        </div>

      </div>
    </article>
  `,
})
export class MsgPopupComponent implements OnInit {
  @Input() config?: MpConfig;
  @Output() clickBtn: EventEmitter<MP_RESULT>;

  protected readonly MP_RESULT = MP_RESULT;

  constructor(
    private lm: LayoutMgrService,
    private globalEventSvc: GlobalEventService,
  ) {
    this.clickBtn = new EventEmitter<MP_RESULT>();
  }

  ngOnInit(): void {
  }


  protected onClickBtn(event: MouseEvent, result: MP_RESULT): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    if (!this.lm.msgPopup$) {
      throw new Error('MsgPopupComponent.onClickBtn: this.lm.msgPopup$ is undefined');
    }
    this.lm.msgPopup$.next(result);
    this.lm.msgPopup$.complete();
  }
}
